import httpClient from "@/_shared/http-client";
import urlBuilder from "@/user/api-services/_urlBuilder";
import { pagination } from "@/_shared/utils";

const getAll = async (currentPage = 1) => {
  let pagesCounter = 1;
  let list = [];
  const url = urlBuilder.buildForLoginHistoryTable(currentPage);
  await httpClient
    .get(url)
    .then((res) => {
      list = res.data.records;
      pagesCounter = pagination.getPagesCounter(res.data.results);
    })
    .catch((error) => {
      throw new Error(error.message);
    });
  return { list, pagesCounter };
};

export const loginHistoryService = { getAll };



// WEBPACK FOOTER //
// ./src/user/api-services/loginHistoryService.js